import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/styles";
import {Colors} from "../../styles/Colors";
import classNames from "classnames";
import {escapeRegExp} from "../TextTranscription/transcription.utils";

interface SearchableTextInterface {
    text: string;
    search?: string;
    bold?: boolean;
    activeFoundIndex?: number;
    markedId?: string;
}

const useStyle = makeStyles(() => ({
    container: {
        maxWidth: '85%',
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        display: "block",
        flex: 1,
        minWidth: 0,
        lineHeight: '19px',
    },
    marked: {
        color: Colors.White,
        backgroundColor: Colors.Primary,
        fontSize: 16,
        height: 'fit-content',
    },
    activeMarked: {
        color: Colors.White,
        backgroundColor: Colors.LightGraySecondary,
        lineHeight: '19px',
    },
    bold: {
        fontWeight: 500,
        color: Colors.Text,
    },
}));

const SearchableText: React.VFC<SearchableTextInterface> = ({ text, search, bold, activeFoundIndex, markedId }) => {
    const classes = useStyle();

    const highlightText = (text: string, search?: string) => {
        if (!search) return text;

        const regex = new RegExp(`(${escapeRegExp(search)})`, 'gi');
        const parts = text.split(regex).filter(Boolean);

        const matches = parts
            .map((item, index) => ({ item, index }))
            .filter(({ item }) => regex.test(item));

        const activeMatch =
            typeof activeFoundIndex === 'number' && activeFoundIndex >= 0
                ? matches[activeFoundIndex]
                : null;

        return parts.map((part, index) => {
            const isMatch = part.toLowerCase() === search.toLowerCase();
            const isActive = activeMatch?.index === index;

            if (isMatch) {
                return (
                    <span
                        key={`match-${index}`}
                        id={isActive && markedId ? markedId : undefined}
                        className={classNames(
                            classes.marked,
                            isActive && classes.activeMarked
                        )}
                    >
                        {part}
                    </span>
                );
            }

            return <span key={`text-${index}`}>{part}</span>;
        });
    };


    useEffect(() => {
        const element = markedId && document.getElementById(markedId);
        element && element.scrollIntoView({behavior: 'smooth', block:  'center', inline: 'nearest'});
    }, [activeFoundIndex]);

    return (
        <div className={classNames(bold && classes.bold, classes.container)}>
            {highlightText(text, search)}
        </div>
    );
};

export default SearchableText;
